import axios from 'axios';

export const SERVICE_NAME = 'Skin Care Cosmetic';
const endpointBase = process.env.REACT_APP_QUANTUMURL;

const resolveFileType = (file) => {
  const extFromName = file?.name?.includes('.') ? '.' + file.name.split('.').pop().toLowerCase() : '';
  const mimeToExt = (m) => (m === 'image/png' ? '.png' : (m === 'image/jpeg' || m === 'image/jpg') ? '.jpg' : '');
  return extFromName || mimeToExt(file?.type || '');
};

export function generateCosmeticUploadUrls(patientId, files) {
  const url = new URL('new_generate-resumable-url', endpointBase).toString();
  const payload = {
    patientId,
    serviceName: SERVICE_NAME,
    files: files.map((file, index) => ({
      fileNumber: index + 1,
      fileType: resolveFileType(file),
      contentType: file?.type || 'application/octet-stream',
    })),
  };
  return axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } }).then((res) => {
    const data = res.data;
    const requestId = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
    return { requestId, uploadUrls: data?.upload_urls || [] };
  });
}

export function uploadCosmeticFile(url, file, onProgress) {
  const contentType = file?.type || 'application/octet-stream';
  return axios.put(url, file, {
    headers: { 'Content-Type': contentType },
    timeout: 60000,
    onUploadProgress: (evt) => {
      if (evt?.loaded && evt?.total > 0) {
        onProgress?.(evt.loaded / evt.total);
      }
    },
  });
}

export function checkCosmeticUploadedFiles({ requestId, sourceChannel, createdBy, signedUrlCount, fileType }) {
  const url = new URL('check-uploaded-files', endpointBase).toString();
  const body = {
    requestId,
    serviceName: SERVICE_NAME,
    sourceChannel,
    createdBy,
    signedUrlCount,
    fileType,
  };
  return axios.post(url, body, { headers: { 'Content-Type': 'application/json', accept: 'application/json' } });
}

export function submitCosmeticInfo(payload) {
  const url = new URL('skincare-cosmetic-info', endpointBase).toString();
  return axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
}

export function getCosmeticReportList({ patientid, pageNumber = 1, pageSize = 10 }) {
  const url = new URL('get_report_list', endpointBase).toString();
  return axios.get(url, {
    params: {
      patientid,
      service: SERVICE_NAME,
      page_number: pageNumber,
      page_size: pageSize,
    },
  });
}

// Single-request alternative to paginating get_report_list — checks on exactly
// one cosmetic skin care submission by its request_id.
// STATUS: 0 queued, 3 backend accepted/polling, 1 done, 2 failed.
export function getCosmeticSkincareStatus(requestId, patientid) {
  const url = new URL(`skincare-cosmetic-status/${requestId}`, endpointBase).toString();
  return axios.get(url, { params: { patientid } });
}

export function getOrderMedicineUrl(drugName) {
  const base = (process.env.REACT_APP_Curebay || 'https://patients-stage-new.curebay.in').replace(/\/$/, '');
  return `${base}/services/order-medicines?search=${encodeURIComponent(drugName)}`;
}

export { resolveFileType };
